
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ValidationProvider } from 'vee-validate';
import InfoBanner from '../shared/suites/InfoBanner.vue';
import ToggleSwitch from '@/components/shared/ToggleSwitch.vue';
import '@/validation-rules';

const namespace: string = 'auth';

@Component<OrderOptionsInfo>({
	components: {
		InfoBanner,
		ToggleSwitch,
		ValidationProvider
	}
})
export default class OrderOptionsInfo extends Vue {
	@Getter('isK12Location', { namespace }) private isK12Location!: boolean;
	@Getter('isCateringRestaurant', { namespace }) private isCateringRestaurant!: boolean;
	@Getter('modifyRequestsEnabled', { namespace }) private modifyRequestsEnabled!: boolean;
	@Getter('isGuestOrderCancellationEnabled', { namespace }) private isGuestOrderCancellationEnabled!: boolean;
	@Getter('getPriceAffixes', { namespace }) private priceAffixes!: PriceAffixes;
	@Prop({ type: Object, default: () => {} }) private targetOrderOptions!: OrderOptions;
	@Watch('targetOrderOptions')
	private onTargetOrderOptionsChange(): void {
		this.mutableOrderOptions = { ...this.targetOrderOptions };
	}

	private mutableOrderOptions: OrderOptions = { ...this.targetOrderOptions };

	/**
	 * Get the order cutoff value in hours or days based on the location type.
	 *
	 * @returns {number}
	 */
	private get orderCutoffValue(): number {
		const hours = this.mutableOrderOptions['order_cutoff_hours'] || 0;
		return this.isK12Location ? hours : hours / 24;
	}

	/**
	 * Convert the order cutoff value to hours if location is not K12.
	 *
	 * @param {number} value
	 * @returns {void}
	 */
	private set orderCutoffValue(value: number) {
		const updatedValue = this.isK12Location ? value : value * 24;
		Vue.set(this.mutableOrderOptions, 'order_cutoff_hours', updatedValue);
	}

	private updateOrderOptions(): void {
		// Don't want to pass a property if empty since it's meaningless
		if (this.mutableOrderOptions) {
			(['max_items_per_cart', 'order_cutoff_hours', 'guest_order_cancellation_cutoff_hours', 'max_advanced_order_days', 'max_advanced_order_days_exclude_weekends', 'order_window_exclude_closed_days', 'min_amount_per_order', 'modification_request_cutoff_hours'] as (keyof OrderOptions)[]).forEach(option => {
				if (!this.mutableOrderOptions[option]) {
					delete this.mutableOrderOptions[option];
				}
			});
		}

		this.$emit('update-order-options', { ...this.mutableOrderOptions });
	}
}
